import { z } from 'zod';
import { AddressSchema, EntityMetaSchema, zNonEmpty } from './common.js';

/**
 * Property — a first-class service location belonging to a customer (Phase II P2-M1). Replaces the
 * embedded `Customer.serviceLocations[]` (kept for back-compat + migration). A property owns access
 * details, equipment, and its own job/service history.
 */
export const PropertySchema = EntityMetaSchema.extend({
  customerId: z.string(),
  label: z.string().trim().max(80).optional(), // "Main home", "Rental #2", "Building A"
  address: AddressSchema,
  accessInstructions: z.string().max(2000).optional(),
  gateCode: z.string().max(60).optional(),
  contactIds: z.array(z.string()).default([]),
  notes: z.string().max(4000).optional(),
  photoKeys: z.array(z.string()).default([]),
  customFields: z.record(z.string(), z.string()).default({}),
});
export type Property = z.infer<typeof PropertySchema>;

export const CreatePropertySchema = z.object({
  customerId: zNonEmpty,
  label: z.string().trim().max(80).optional(),
  address: AddressSchema,
  accessInstructions: z.string().max(2000).optional(),
  gateCode: z.string().max(60).optional(),
  contactIds: z.array(z.string()).optional(),
  notes: z.string().max(4000).optional(),
  customFields: z.record(z.string(), z.string()).optional(),
});
export type CreatePropertyInput = z.infer<typeof CreatePropertySchema>;

export const UpdatePropertySchema = CreatePropertySchema.partial().omit({ customerId: true });
export type UpdatePropertyInput = z.infer<typeof UpdatePropertySchema>;
